import { render } from "./NavbarVue.vue?vue&type=template&id=f2b5658a&scoped=true"
import script from "./NavbarVue.vue?vue&type=script&lang=js"
export * from "./NavbarVue.vue?vue&type=script&lang=js"

import "./NavbarVue.vue?vue&type=style&index=0&id=f2b5658a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Desktop\\PROJECTS\\portfolio\\v1\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2b5658a"]])

export default __exports__